import { useReducer, useRef } from 'react'

interface State {
    open: boolean
    selectedItem?: AnnotationExportRegistryConfigObj
}

enum ActionTypes {
    openDropdown,
    closeDropdown,
    selectExportOption
}

interface AbstractAction {
    type: ActionTypes
}

interface SelectExportOptionAction extends AbstractAction {
    type: ActionTypes.selectExportOption
    selectedItem: AnnotationExportRegistryConfigObj
}

interface OpenDropdownAction extends AbstractAction {
    type: ActionTypes.openDropdown
}

interface CloseDropdownAction extends AbstractAction {
    type: ActionTypes.closeDropdown
}

type Action = SelectExportOptionAction | OpenDropdownAction | CloseDropdownAction

function reducer(state: State, action: Action): State {
    switch (action.type) {
        case ActionTypes.openDropdown:
            return { open: true }
        case ActionTypes.closeDropdown:
            return { open: false }
        case ActionTypes.selectExportOption:
            return { open: true, selectedItem: action.selectedItem }
        default:
            throw new Error()
    }
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const actionDispatcherGenerator = (dispatcher: React.Dispatch<Action>) => ({
    openDropdown: () => dispatcher({ type: ActionTypes.openDropdown }),
    closeDropdown: () => dispatcher({ type: ActionTypes.closeDropdown }),
    selectExportOption: (selectedItem: AnnotationExportRegistryConfigObj) =>
        dispatcher({ type: ActionTypes.selectExportOption, selectedItem })
})

type ActionDispatcher = ReturnType<typeof actionDispatcherGenerator>

const useExportAnnotationReducer = (): [State, ActionDispatcher] => {
    const [state, dispatcher] = useReducer(reducer, { open: false })
    const actionsRef = useRef<ActionDispatcher>(actionDispatcherGenerator(dispatcher))

    return [state, actionsRef.current]
}

export default useExportAnnotationReducer
